"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullJitter = void 0;
function fullJitter(delay) {
    const jitteredDelay = Math.random() * delay;
    return Math.round(jitteredDelay);
}
exports.fullJitter = fullJitter;
